export default __webpack_public_path__ + "static/media/10.29fbed6e.webp";